import React from 'react'
import Link from 'gatsby-link'


const NewsletterPage = () => {


  return (
    <div className="component--centered mb bordered">

      <h1>Want to be notified when I publish new tutorials and when I have something Important to say/ask?</h1>
      <p>Tutorials and Articles on Javascript, React, Express, GraphQL, MongoDB, Microservices, Serverless, Continuous Deployment and more.</p>

      <div>
        <label htmlFor="EMAIL" style={{ cursor: 'pointer' }}>Please enter your email address below.</label>
        <div className="input" style={{ marginTop: 10 }}>
        <form method="post" action="https://dhruvkumarjha.us17.list-manage.com/subscribe/post?u=489b7ba732e0457406dc20898&amp;id=3c3df9a3d9" className="default flex" target="_blank">
          <input style={{ width: '80%' }} type="text" name="EMAIL" id="EMAIL" placeholder="john.doe@gmail.com" />
          <button className="button button--green size--medium" type="submit">Subscribe Me</button>
        </form>
        </div>
      </div>

    </div>
  )

}

export default NewsletterPage




// WEBPACK FOOTER //
// ./src/pages/newsletter.js